(function() {
'use strict';

angular.module('GorillaBoy.services')
.factory('AnnotationService', [
    '$log',
    '$timeout',
    'BaseService',
    'AppConstants',
    'EndpointService',
    'ClientMetricsService',
    'BaseHttpService',
    AnnotationService
]);

function AnnotationService($log, $timeout, BaseService, AppConstants, EndpointService, ClientMetricsService, BaseHttpService) {

     var httpMethods = AppConstants.HttpMethods,
        permissions = AppConstants.Permissions,
        SERVICE_ROOT = function(isNewAPI) {
            return isNewAPI ? EndpointService.endpoint(true) + 'documents/' : EndpointService.endpoint() + 'document/';
        },
        REGENERATED_ANNOTATION_INDEX_DOWNLOAD_TIMEOUT = 5000;


    var annotationsModel = {};

    annotationsModel = {};

    annotationsModel.getAnnotationIndex = function(indexUrl) {
        return BaseHttpService.callWithExpRetries({
            method : httpMethods.GET,
            url: indexUrl
        }).then(function(response) {
            annotationsModel.annotationIndex = response.data;
            return response.data;
        });
    };

    // Updates the annotation index, making a check for trueFormat.
    // If not in trueFormat, makes a server call to re-generate the annotation index.
    // After regenerate call, waits for 5s and downloads the annotation index again.
    annotationsModel.updateAnnotationIndex = function(data, documentId, versionId){
        annotationsModel.annotationIndex = data;
        if (!annotationsModel.annotationIndex.trueFormat) {
            $log.info("Detected old format annotation index." +
                "Sending request to regenerate annotation index. Document ID : "+
                documentId + "; Version ID : " + versionId);

           ClientMetricsService.addJsOperationToSession('Detected Old Format Annotation', true);

            var successCallback = function(response){
                $log.info("Successfully called generateAnnotationIndex for Document ID : " +
                            documentId +"; Version ID : " + versionId);
                ClientMetricsService.addJsOperationToSession('Generated New Format Annotation', true);
                $timeout(annotationsModel.downloadAnnotationIndex,
                    REGENERATED_ANNOTATION_INDEX_DOWNLOAD_TIMEOUT, true,
                    annotationsModel.annotationIndexUrl); // wait 5s for the async annotation generation task to complete
            };

            var errorCallback = function(response){
                $log.error("Error calling generateAnnotationIndex. Maybe this API is not supported? Detail : " + JSON.stringify(response));
                ClientMetricsService.addJsOperationToSession('Failed Generating New Format Annotation', true);
            };

            annotationsModel.callGenerateAnnotationIndex(documentId, versionId)
            .then(successCallback, errorCallback);

        } else {
            $log.info("Detected true format annotation index. Not Sending request to regenerate annotation index.");
        }

    };

    annotationsModel.downloadAnnotationIndex = function(downloadLink) {
        $log.info("Downloading annotation index afresh from downloadLink : " + downloadLink);

        var successCallback = function(response){
            annotationsModel.annotationIndex = angular.fromJson(response.data);
            $log.info("Is the freshly downloaded annotation index in true format? : " + annotationsModel.annotationIndex.trueFormat);
        };
        var errorCallback = function(response){
             $log.error("Error downloading fresh annotation index from URL : " +
                downloadLink + "; Error : " + JSON.stringify(response));
        };

        var config = {
            url: downloadLink,
            method: httpMethods.GET,
        };
        return BaseService.callOnce(config).then(successCallback, errorCallback);
    };

    annotationsModel.callGenerateAnnotationIndex = function(documentId, versionId) {
        var config = {
            url: SERVICE_ROOT(true) + documentId + '/versions/' + versionId +
                                    '/generateAnnotationIndex',
            method: httpMethods.GET,

        };
        return BaseService.callOnce(config);
    };
    return annotationsModel;
}

}());
